import { Alert, Button, Empty, Space, Typography } from 'antd';
import { IconFilePlus, IconDownload } from '@tabler/icons-react';

const { Text } = Typography;

export function RequestsTab() {
  return (
    <div>
      <Space style={{ marginBottom: 16 }}>
        <Button type="primary" icon={<IconFilePlus size={16} />} disabled>
          Сформировать заявку
        </Button>
        <Button icon={<IconDownload size={16} />} disabled>
          Выгрузить
        </Button>
      </Space>

      <Alert
        type="warning"
        showIcon
        style={{ marginBottom: 24, width: '100%' }}
        message="Недоступно в demo-режиме. Формирование заявок на обучение будет доступно в следующей версии."
      />

      <Empty description={<Text type="secondary">Заявки на обучение пока не созданы</Text>} />
    </div>
  );
}
